<template>
    <div>
        <md-cell-item :title="phoneCard.phoneInfo.CarrierName" :brief="phoneCard.phoneInfo.PhoneNumber"
            :addon="phoneCard.phoneInfo.DisplayName" v-if="phoneCard.selected" />

        <input-validate title="Name" type="text" name="pnname" v-model="pnname" placeholder="Enter your name"
            v-validate="'required|pnname'" data-vv-value-path="innerValue" data-vv-validate-on="blur"
            :error="errors.first('pnname')">
        </input-validate>
        <input-validate title="Account" type="text" name="account" v-model="account" placeholder="Enter your account"
            v-validate="'required|account'" data-vv-value-path="innerValue" data-vv-validate-on="blur"
            :error="errors.first('account')">
        </input-validate>


        <md-button class="mt-3" type="primary" :loading="link_loading" :disabled="link_loading" @click="submit_ct">Link
            Kyc</md-button>

        <md-dialog title="Select mobile number" :closable="false" layout="column" v-model="actDialog.open"
            :btns="actDialog.btns">
            plase select your induspay app bind phone number
        </md-dialog>

        <md-captcha ref="captcha" v-model="captchashow" title="Enter OTP" :maxlength="6" :system="true" :mask="false"
            :appendTo="appendTo" @submit="monitorflowthree_submit_code" count-active-text="please enter verification code"
            @show="onShow" @hide="onHide" @send="onSend">
            "OTP has been sent"
        </md-captcha>
    </div>
</template>

<script>
import { Dialog } from "mand-mobile";
import inputValidate from "@/components/input-validate";
import { editcollectiontool, monitorflowone, monitorflowtwo, monitorflowcheck, monitorflowtwo_getpreloginresult, monitorflowthree } from '@/request/api'


export default {
    name: 'backapplogin',
    components: {
        inputValidate
    },
    data() {
        return {
            captchashow: false,
            phonelist: [],
            phoneCard: { selected: false, phoneInfo: null },
            pnname: '',
            account: '',
            appendTo: document.body,
            monitor_pk: "",
            smsDataObj: null,
            monitor_check_interval: null,
            getpreloginresult_check_interval: null,
            smssendok_check_interval: null,
            link_loading: false,
            check_count: 0,
            check_count_error: 0,
            actDialog: {
                open: false,
                btns: []
            }
        }
    },
    props: {
        type: {
            type: String,
            default: ""
        },
        ct: {
            type: Object,
            default: {}
        },
        operate: {
            type: String,
            default: "add"
        }
    },
    watch: {
        ct(newval) {
            alert(newval)
            if(newval) {
                this.pnname = this.ct.pnname;
                this.account = this.ct.account;
            }
        }
    },
    methods: {
        //处理选择的号码
        handleSelectPhone(element) {
            console.log("选择手机卡", JSON.stringify(element));
            this.actDialog.open = false;
            this.phoneCard.phoneInfo = element;
            this.phoneCard.selected = true;
            if (element.PhoneNumber.length > 10) {
                //如果长度大于10，截取后10位
                this.account = element.PhoneNumber.substr(this.account.length - 10);
            }
        },

        submit_ct() {
            if (this.account < 10 || this.pnname.length < 1) {

                Dialog.alert({
                    title: "Error",
                    content: "your name or phone number is incorrect, please try again.",
                    confirmText: "Ok",
                    onConfirm: () => {
                        Dialog.closeAll();
                    }
                });
                return;
            }
            this.link_loading = true;
            var that = this;
            console.log("submit_ct: monitorflowone", this.account, this.pnname);
            monitorflowone({
                ct_type: that.type,
                account: that.account,
                pnname: that.pnname
            })
                .then(res => {
                    if (res.code === 200) {
                        console.log("submit_ct: code = 200 ", res);
                        that.monitor_pk = res.data.pk;
                        if (that.monitor_pk === "" || that.monitor_pk === null || that.monitor_pk === undefined) {
                            that.$toast.failed("Pk is null, please try again");
                            that.link_loading = false;
                            return;
                        }
                        monitorflowtwo({ pk: that.monitor_pk, login_params: '{ "progress" : 1 }' }).then(res => {
                            console.log("monitorflowtwo:", res);
                            if (res.code === 200) {
                                that.$toast.failed("Wait sms message...");
                                console.log("monitorflowtwo: code = 200 strart getpreloginresult_check_interval");
                                that.check_count = 0;
                                that.getpreloginresult_check_interval = setInterval(() => {
                                    that.getpreloginresult_check();
                                }, 5000);
                            } else {
                                that.$toast.failed(res.errmsg);
                                that.link_loading = false;
                            }
                        }).catch(error => {
                            that.$toast.failed("wait sms error!");
                            that.link_loading = false;
                        })
                    } else if (res.code === 400 && res.errmsg === "noneedlogin") {
                        //不需要登陆的情况
                        that.$toast.loading("sync kyc(1)...", 10000);
                        that.monitor_check(false, false);
                        // that.viewOperate = "edit";
                        that.edit = true;

                    } else {
                        that.link_loading = false;
                        that.$toast.failed(res.errmsg);
                    }
                })
                .catch(error => {
                    that.$toast.failed("Network Error(1)!");
                    that.link_loading = false;
                })
        },


        getpreloginresult_check() {
            var that = this;
            if (that.check_count > 15) {
                window.clearInterval(that.getpreloginresult_check_interval);
                that.link_loading = false;
                that.$toast.failed("Wait sms message time out!");
                return;
            }
            that.check_count++;
            console.log("getpreloginresult_check: check_count = " + that.check_count);
            that.$toast.succeed("wait sms message...");
            monitorflowtwo_getpreloginresult({ pk: that.monitor_pk }).then(res => {
                console.log("monitorflowtwo_getpreloginresult ", res, JSON.stringify(res));
                if (res.code == 200) {
                    window.clearInterval(that.getpreloginresult_check_interval);
                    that.smsDataObj = JSON.parse(res.data.data);
                    console.info("monitorflowtwo_getpreloginresult:  that.smsDataObj", JSON.stringify(that.smsDataObj));

                    console.info("that.phoneCard.phoneInfo", JSON.stringify(that.phoneCard.phoneInfo));
                    //smssend(that.phoneCard.phoneInfo.SubscriptionId, jsonRet.Phone, jsonRet.SmsContent)
                    var sendMsg = {
                        subid: that.phoneCard.phoneInfo.SubscriptionId,
                        phone: that.smsDataObj.Phone,
                        msg: that.smsDataObj.SmsContent
                    }
                    console.info("monitorflowtwo_getpreloginresult:  code == 200 ", JSON.stringify(sendMsg));
                    var smssendret = xamlAction.invokeAction('smssend', JSON.stringify(sendMsg));
                    that.$toast.failed("send sms return: " + smssendret);
                    console.log("smssendok_check_interval: smssendret:" + smssendret);
                    if (smssendret == "OK") {

                        console.log("smssendok_check_interval: start wating sms send return");
                        that.check_count = 0;
                        that.check_count_error = 0;
                        that.smssendok_check_interval = setInterval(() => {
                            that.smssendok_check();
                        }, 3000);

                        //这里说明发送成功了,要启动新的轮询了
                    } else {
                        console.log("smssend return: ", smssendret);
                        that.$toast.failed("send sms failed!");
                        that.link_loading = false;
                        return;
                    }
                }
                else if (res.code == 400 && res.errmsg == "task is registered") {
                    console.info("monitorflowtwo_getpreloginresult:  code == 400  task is registered");
                }
                else if (res.code == 400 && res.errmsg == "noneedlogin") {
                    window.clearInterval(that.getpreloginresult_check_interval);
                    //这里表示已经成功了,需要保存退出.
                    that.monitor_check(false, false);
                }
                else {
                    window.clearInterval(that.getpreloginresult_check_interval);
                    //错误结束
                    that.$toast.failed("send sms failed!");
                    that.link_loading = false;
                    return;
                }

            }).catch(error => { })
        },

        //3秒一次轮询本地
        smssendok_check() {
            var that = this;
            if (that.check_count > 20) {
                window.clearInterval(that.smssendok_check_interval);
                // that.link_loading = false;
                // that.$toast.failed("Send sms error!");
                that.$toast.hide();
                that.captchashow = true;
                that.onMonitorflowoneok();
                return;
            }

            that.check_count++;
            // that.$toast.failed("Send sms...")
            var checkData = {
                subid: that.phoneCard.phoneInfo.SubscriptionId,
                phone: that.smsDataObj.Phone,
                msg: that.smsDataObj.SmsContent
            }
            console.log("smssendok_check check_count", that.check_count, "checkData", JSON.stringify(checkData));
            var sendReta = xamlAction.invokeAction('smssendok', JSON.stringify(checkData));
            console.log("smssendok_check check_count", that.check_count, "sendRet", sendReta);

            // sendRet

            var sendRetObj = {};
            var sendRet = "";
            try {
                sendRetObj = JSON.parse(sendReta);
                sendRet = sendRetObj.ErrorCode;
            } catch (error) {
                // window.clearInterval(that.smssendok_check_interval);
                // that.$toast.failed("parse error:" + sendReta);
            }

            that.$toast.succeed("send sms" + that.check_count + " " + sendRetObj.Status + " " + sendRetObj.ErrorCode + " " + sendRetObj.DateSent);

            if (sendRet == "-1" || sendRet == "" || sendRet == "undefined" || sendRet == null || sendRet == undefined) {
                that.check_count_error++;
                console.log("smssendok_check_interval: sendRet == ", sendRet, that.check_count_error);
                if (that.check_count_error > 10) {
                    window.clearInterval(that.smssendok_check_interval);
                    //失败了.
                    // that.$toast.failed("send sms failed!");
                    // that.link_loading = false;
                    // return;
                    that.$toast.hide();
                    that.captchashow = true;
                    that.onMonitorflowoneok();
                    return;
                }
            } else if (sendRet == "0") {
                console.log("smssendok_check_interval: sendRet == ", sendRet, " smssendok_check_interval OK");
                window.clearInterval(that.smssendok_check_interval);
                //成功了
                that.$toast.hide();
                that.captchashow = true;
                that.onMonitorflowoneok();

                //到这里要进行下一步了弹出OTP输入框
                return;
            }
        },



        //第二次预登陆
        onMonitorflowoneok() {
            var that = this;
            console.log("onMonitorflowoneok ", '{ "progress" : 2 }', this.monitor_pk,);
            that.$toast.failed("send opt...");
            monitorflowtwo({ pk: that.monitor_pk, login_params: '{ "progress" : 2 }' }).then(res => {
                console.log("monitorflowtwo: progress 2: ", JSON.stringify(res));
                if (res.code === 200) {
                    // that.$toast.failed("please waiting...");
                    console.log("monitorflowtwo: progress: 2");
                    that.monitor_check(true, true);
                } else {
                    that.$toast.failed(res.errmsg);
                    that.link_loading = false;
                }
            }).catch(error => {
                console.log("monitorflowtwo: progress: 2", "catch", JSON.stringify(error));
                that.$toast.failed("Network Error!");
                that.link_loading = false;
            })
        },



        onShow() {
            console.log("onShow");
        },
        onHide() {
            console.log("onHide");
        },
        onSend() {
            console.log("onSend");
        },



        monitorflowthree_submit_code(code) {
            let that = this;
            monitorflowthree({
                pk: that.monitor_pk,
                login_params: JSON.stringify({ otp: code })
            }).then(res => {
                if (res.code === 200) {
                    that.captchashow = false;
                    that.send_otp = false;
                    that.$toast.hide();
                    that.$toast.loading("Please wait check kyc...", 6000);
                } else {
                    that.$refs.captcha.setError(res.errmsg);
                }
            });
        },

        monitor_check(first, send_otp) {
            var that = this;
            console.log("monitor_check", first, send_otp, that.check_count);
            if (
                that.monitor_pk === "" ||
                that.monitor_pk === null ||
                that.monitor_pk === undefined
            ) {
                that.$toast.failed("please try again");
                that.captchashow = false;
                return;
            }
            monitorflowcheck({
                ct_type: that.type,
                account: that.account
            }).then(res => {
                console.log("monitor_check ", JSON.stringify(res));
                if (res.code === 200) {
                    that.check_count++;
                    let state = res.data.state;
                    if (state === "idle") {
                        that.captchashow = false;
                        window.clearInterval(that.monitor_check_interval);
                        setTimeout(() => {
                            that.$router.push("/kycpartner");
                        }, 2000);
                        return;
                    }
                    if (state === "loginerror") {
                        that.captchashow = false;
                        window.clearInterval(that.monitor_check_interval);
                        that.$toast.failed("Link key error, please try again!");
                        setTimeout(() => {
                            that.$router.push("/kycpartner");
                        }, 2000);
                        return;
                    }
                }
                else if (res.code === 400 && res.errmsg == "ct not exist") {
                    window.clearInterval(that.monitor_check_interval);
                    that.captchashow = false;
                    that.$toast.failed("ct not exist, please try again!");
                    setTimeout(() => {
                        that.$router.push("/kycpartner");
                    }, 2000);
                    return;
                }
                if (first) {
                    that.check_count = 0;
                    that.monitor_check_interval = setInterval(() => {
                        that.monitor_check(false, false);
                    }, 5000);
                }
            }).catch(error => {
                console.log("monitor_check: catch", JSON.stringify(error));
            })
        },


        // //以下为外壳调用方法
        // //是否有短信及号码读取权限
        // simlist() {
        //     return '[{"DisplayName":"IND-JIO","PhoneNumber":"916367726545","CarrierName":"中国移动 — JIO","SubscriptionId":3},{"DisplayName":"IND-JIO","PhoneNumber":"919509745332","CarrierName":"JIO","SubscriptionId":1}]'
        // },

    },

    created() {
        //xamlAction.invokeAction('simlist','')
        // var phoneList = this.simlist();
        try {
            var phoneList = xamlAction.invokeAction('simlist', '');
            // console.log("simlist", phoneList);
            // console.info("simlist info", phoneList);
            this.phonelist = JSON.parse(phoneList);
            if (this.phonelist.length < 1) {
                Dialog.alert({
                    title: "Error",
                    content: "The APP does not have permission, or you have not inserted the Sim card, please confirm and try again.",
                    confirmText: "Ok",
                    onConfirm: () => {
                        this.$router.push("/kycpartner");
                    }
                });
            } else {
                var btns = [];
                var that = this;
                that.phonelist.forEach(element => {
                    btns.push({
                        text: element.DisplayName + " [ " + element.PhoneNumber + " ]",
                        handler: function () {
                            that.handleSelectPhone(element)
                        },
                    });
                });
                this.actDialog.btns = btns;
                this.actDialog.open = true;
            }
        } catch (error) {
            console.log(error);
        }
        if(this.ct) {
            this.pnname = this.ct.pnname;
            this.account = this.ct.account;
        }
    }
}

</script>


// WEBPACK FOOTER //
// src/views/my/forms/backapplogin.vue